<template lang="pug">
div(style="overflow-x: hidden")
    v-container.default-container
        .points-container
            .points-backround(style="pointer-events: none")
                img.ticketeer(src="../assets/ticketeer.svg" width="400")
            div(style="max-width: 750px")                
                h2 Main Concepts
                p Your ticket sales are powered by TS smart contract.
                p You can choose to authorize resellers to deploy TS and sale tickets for your event, while customers 
                    | are able to verify the seller cretibility trough included informations in TS.
                p Customers are able to verify originality and number of tickets they own.
                p TS is expected to work in a direct integration with wallet applications, which should expose all client sight functionality in simple and user friendly manner.
                p(style="margin-top: 4em; margin-bottom: 0px !important;") TS is available under AGPL license to secure open and consistent development.


</template>

<script>
    export default {
        name: 'Concepts',

        data: () => ({
        
        }),
    }
</script>

<style lang="stylus" scoped>
.points-container
    position relative
    max-width: 1200px !important

@media (max-width 1200px) {
    max-width 100vw !important
}

.points-backround
    position absolute
    display flex
    align-content center
    align-items center
    justify-content center
    height: 100%
    width: 100%

.ticketeer
    position absolute
    filter: invert(65%) sepia(6%) saturate(4986%) hue-rotate(191deg) brightness(87%) contrast(87%);
    margin-left: 500px 
    width 400px !important
    height auto

</style>
